import { Col, Row } from "antd";
import type { FC } from "react";
import { useSearchParams } from "react-router";

import { fullWidthComponents } from "../../../oldSrc/oldComponents/Form/GenericForm/GenericForm";
import type { FormFieldRenderProps } from "../types";
import { FormComponent } from "../types/types";
import { ConditionalWrapper } from "./ConditionalWrapper/ConditionalWrapper";
import { getFieldLinkHrefBuilder } from "./entityLink";
import { FieldWithEntityLink } from "./FieldWithEntityLink";
import { getValidationRules } from "./Validations/ValidationFieldsFactory";

export const FormFieldRender: FC<FormFieldRenderProps> = ({ factory, field, readOnly, onChange, readOnlyField, isVisible }) => {
    const [searchParams] = useSearchParams();
    const validationRules = getValidationRules(field.attributes?.validationRules);
    // Merge backend validationRules with custom dynamic rules (e.g., conditional required validation in acquirer) injected via field.rules
    const rules = [...validationRules, ...(field.rules ?? [])];

    // check if the RO field is RO
    const isROFieldRO = readOnlyField && readOnlyField.attributes?.readOnly === true;

    const fieldComponent = factory({
        field,
        readOnly,
        rules,
        changeCallback: onChange,
    });
    const fieldComponentRO = !readOnlyField
        ? null
        : factory({
              field: readOnlyField,
              readOnly: isROFieldRO || readOnly,
              changeCallback: onChange,
          });

    const isFullWidth = !!field?.component && fullWidthComponents.includes(field.component);
    const isDynamicProperties = field?.component === FormComponent.DYNAMIC_PROPERTIES;
    const isNoWrapTextArea = field?.component === FormComponent.TEXT_AREA && field?.attributes?.noWrap;
    const buildLinkHref = getFieldLinkHrefBuilder(field, searchParams);

    let fieldRow = (
        <>
            {/* z-index needed: flex items paint in DOM order, so Col 8's content would otherwise cover the link */}
            <Col span={14} style={buildLinkHref ? { position: "relative", zIndex: 1 } : undefined}>
                <FieldWithEntityLink field={field} fieldComponent={fieldComponent} buildLinkHref={buildLinkHref} />
            </Col>
            <Col span={8}>{fieldComponentRO}</Col>
        </>
    );
    if (isDynamicProperties) {
        fieldRow = <Col span={16}>{fieldComponent}</Col>;
    } else if (isFullWidth) {
        fieldRow = <Col span={24}>{fieldComponent}</Col>;
    } else if (isNoWrapTextArea) {
        fieldRow = <Col span={20}>{fieldComponent}</Col>;
    }

    return (
        <ConditionalWrapper key={`${field.name}-wrapper`} fieldConfig={field}>
            <Row gutter={20} hidden={!isVisible}>
                {fieldRow}
            </Row>
        </ConditionalWrapper>
    );
};
